import Api from '../Api';

export default class Nspharm extends Api {
  async getSaldo() {
    const response = await this.get('/nspharm/saldo');
    return response;
  }
}
